import { ApiServiceProps } from "DataTypes/Services/Index.type";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { post } from ".";
import {
  BELL_UNREAD_DAYS,
  parseNotificationCount,
} from "Constant/NotificationBell";

const list: () => any = () => {
  const socket = new SockJS(
    `${process.env.REACT_APP_NOTIFICATION_URL}/notification/wss`
  );
  return Stomp.over(socket);
};

const search: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "notification/search",
    data: {
      data: payload.data,
      criterion: {
        offset: payload.offset,
        limit: payload.limit,
      },
    },
  };
  return post(request);
};

const count: (payload?: ApiServiceProps) => Promise<number> = async (payload) => {
  const request = {
    subUrl: "notification/count",
    data: {
      data: {
        isNotificationRead: false,
        createdWithinDays: BELL_UNREAD_DAYS,
        ...(payload?.data || {}),
      },
    },
  };
  const res: any = await post(request);
  if (res?.success) {
    return parseNotificationCount(res.data);
  }
  return 0;
};

const markAsRead: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `notification/${payload.id1}/mark-as-read`,
    data: {},
  };
  return post(request);
};

const markDelete: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `notification/${payload.id1}/delete`,
    data: {},
  };
  return post(request);
};

export default { list, search, count, markAsRead, markDelete };
